// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Let_syntax from "../../../../packages/core/lib/Let_syntax.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_journal_log_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_manager_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_service.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service from "../../../../proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.js";
import * as Curry from "melange.js/curry.js";

const Types = {};

const Kkm = {};

const EtpLink = {};

function toCreateRequest(form) {
  return Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.CreateKkmRequest.make, form, undefined);
}

const KkmCreateForm = {
  toCreateRequest: toCreateRequest
};

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.UpdateKkmRequest.make, id, form, undefined);
}

function toRequest(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.RegisterKkmRequest.make, id, form, undefined);
}

function toRequest$1(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.ChangeRegisterKkmRequest.make, id, form, undefined);
}

function toRequest$2(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.UnregisterKkmRequest.make, id, form, undefined);
}

function toLinkRequest(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.LinkKkmRequest.make, id, form, undefined);
}

function toConnectRequest(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.ConnectKkmRequest.make, id, form, undefined);
}

const apiEndpointPrefix = "/kassa";

function view(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.GetKkmRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.getKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.GetKkm.name, undefined, undefined));
}

function getRunningBalance(tenant, param, id, param$1) {
  const request = Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.GetRunningBalanceRequest.make, id, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.balance);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.getRunningBalance, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.GetRunningBalance.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.ListKkmsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.kkms;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.listKkms, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.ListKkms.name, undefined, undefined));
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toCreateRequest(form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.createKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.CreateKkm.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toUpdateRequest(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.updateKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.UpdateKkm.name, undefined, undefined));
}

function start(tenant, id, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.StartKkmRequest.make, id, undefined), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.startKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.StartKkm.name, undefined, undefined));
}

function register(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.registerKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.RegisterKkm.name, undefined, undefined));
}

function changeRegister(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$1(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.changeRegisterKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.ChangeRegisterKkm.name, undefined, undefined));
}

function unregister(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$2(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.unregisterKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.UnregisterKkm.name, undefined, undefined));
}

function link(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toLinkRequest(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.linkKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.LinkKkm.name, undefined, undefined));
}

function activate(tenant, id, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.ActivateKkmRequest.make, id, undefined), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.activateKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.ActivateKkm.name, undefined, undefined));
}

function connect(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.kkm);
  }), Buhta_core__Grpc.makeRpc(undefined, toConnectRequest(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.connectKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.ConnectKkm.name, undefined, undefined));
}

function $$delete(tenant, id, param) {
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.DeleteKkmRequest.make, id, undefined), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.deleteKkm, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_manager_service.Buhta.Kassa.V1alpha1.KkmManagerService.DeleteKkm.name, undefined, undefined), (function (result) {
    if (result.TAG === /* Ok */ 0) {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    } else {
      return {
        TAG: /* Error */ 1,
        _0: result._0
      };
    }
  }));
}

const KkmManagerService = {
  view: view,
  getRunningBalance: getRunningBalance,
  grid: grid,
  create: create,
  update: update,
  start: start,
  register: register,
  changeRegister: changeRegister,
  unregister: unregister,
  link: link,
  activate: activate,
  connect: connect,
  $$delete: $$delete
};

function toRequest$3(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.CreateEtpLinkRequest.make, id, form, undefined);
}

function toRequest$4(id, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.UpdateEtpLinkRequest.make, id, form, undefined);
}

function view$1(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.GetEtpLinkRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.link;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.getEtpLink, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.GetEtpLink.name, undefined, undefined));
}

function create$1(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.link);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$3(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.createEtpLink, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.CreateEtpLink.name, undefined, undefined));
}

function update$1(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.link);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$4(id, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.updateEtpLink, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.UpdateEtpLink.name, undefined, undefined));
}

function reset(tenant, id, param) {
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.ResetEtpLinkRequest.make, id, undefined), Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.resetEtpLink, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_etp_service.Buhta.Kassa.V1alpha1.KkmEtpService.ResetEtpLink.name, undefined, undefined), (function (result) {
    if (result.TAG === /* Ok */ 0) {
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    } else {
      return {
        TAG: /* Error */ 1,
        _0: result._0
      };
    }
  }));
}

const KkmEtpService = {
  view: view$1,
  create: create$1,
  update: update$1,
  reset: reset
};

const Receipt = {};

const MoneyPlacement = {};

const ZxReport = {};

const JournalLog = {};

const EtpOrder = {};

function makeItem(item_typeOpt, name, item_price, qty, param) {
  const item_type = item_typeOpt !== undefined ? item_typeOpt : /* ITEM_TYPE_COMMODITY */ 1;
  return Curry.app(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptItemData.make, [
    item_type,
    name,
    item_price,
    qty,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined
  ]);
}

function makePayment(payment_type, amount, param) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptPaymentData.make, payment_type, amount, undefined);
}

function make(operation_typeOpt, itemsOpt, paymentsOpt, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : /* OPERATION_TYPE_SALE */ 1;
  const items = itemsOpt !== undefined ? itemsOpt : /* [] */ 0;
  const payments = paymentsOpt !== undefined ? paymentsOpt : /* [] */ 0;
  return Curry.app(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptData.make, [
    operation_type,
    undefined,
    items,
    payments,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined
  ]);
}

function toRequest$5(kkm, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.CreateReceiptRequest.make, kkm, form, undefined);
}

const ReceiptForm = {
  makeItem: makeItem,
  makePayment: makePayment,
  make: make,
  toRequest: toRequest$5
};

function toRequest$6(kkm, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.CreateMoneyPlacementRequest.make, kkm, form, undefined);
}

function toRequest$7(kkm, form) {
  return Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.CloseShiftRequest.make, kkm, form, undefined);
}

function view$2(param, expandOpt, etpKey, orderNum, receiptNum, param$1) {
  const expand = expandOpt !== undefined ? expandOpt : ({
      hd: "receipt.org",
      tl: {
        hd: "receipt.kkm",
        tl: {
          hd: "receipt.items",
          tl: {
            hd: "receipt.payments",
            tl: {
              hd: "receipt.notes",
              tl: {
                hd: "receipt.taxes",
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    });
  const request = Curry._5(Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service.Buhta.Kassa.V1alpha1.GetEtpOrderRequest.make, etpKey, orderNum, receiptNum, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.order);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service.Buhta.Kassa.V1alpha1.EtpReceiptService.getEtpOrder, undefined, undefined, undefined, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_receipt_service.Buhta.Kassa.V1alpha1.EtpReceiptService.GetEtpOrder.name, undefined, undefined));
}

const EtpReceiptService = {
  view: view$2
};

function view$3(tenant, kkm, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._4(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.GetReceiptRequest.make, kkm, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.receipt);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.getReceipt, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.GetReceipt.name, undefined, undefined));
}

function grid$1(tenant, kkm, params, param) {
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ListReceiptsRequest.make, kkm, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.receipts;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.listReceipts, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.ListReceipts.name, undefined, undefined));
}

function create$2(tenant, kkm, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.receipt);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$5(kkm, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.createReceipt, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_service.Buhta.Kassa.V1alpha1.ReceiptService.CreateReceipt.name, undefined, undefined));
}

const ReceiptService = {
  view: view$3,
  grid: grid$1,
  create: create$2
};

function view$4(tenant, kkm, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._4(Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.GetMoneyPlacementRequest.make, kkm, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.money_placement);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.getMoneyPlacement, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.GetMoneyPlacement.name, undefined, undefined));
}

function grid$2(tenant, kkm, params, param) {
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.ListMoneyPlacementsRequest.make, kkm, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.money_placements;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.listMoneyPlacements, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.ListMoneyPlacements.name, undefined, undefined));
}

function create$3(tenant, kkm, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.money_placement);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$6(kkm, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.createMoneyPlacement, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement_service.Buhta.Kassa.V1alpha1.MoneyPlacementService.CreateMoneyPlacement.name, undefined, undefined));
}

const MoneyPlacementService = {
  view: view$4,
  grid: grid$2,
  create: create$3
};

function view$5(tenant, kkm, expandOpt, id, param) {
  const request = Curry._4(Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.GetZxReportRequest.make, kkm, id, undefined, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.zx_report);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.getZxReport, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.GetZxReport.name, undefined, undefined));
}

function grid$3(tenant, kkm, params, param) {
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ListZxReportsRequest.make, kkm, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.zx_reports;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.listZxReports, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.ListZxReports.name, undefined, undefined));
}

function createXReport(tenant, kkm, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.zx_report);
  }), Buhta_core__Grpc.makeRpc(undefined, Curry._2(Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.CreateXReportRequest.make, kkm, undefined), Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.createXReport, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.CreateXReport.name, undefined, undefined));
}

function closeShift(tenant, kkm, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.zx_report);
  }), Buhta_core__Grpc.makeRpc(undefined, toRequest$7(kkm, form), Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.closeShift, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report_service.Buhta.Kassa.V1alpha1.ZxReportService.CloseShift.name, undefined, undefined));
}

const ZxReportService = {
  view: view$5,
  grid: grid$3,
  createXReport: createXReport,
  closeShift: closeShift
};

function grid$4(tenant, kkm, params, param) {
  const request = Curry._3(Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log_service.Buhta.Kassa.V1alpha1.ListJournalLogsRequest.make, kkm, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.journal_logs;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log_service.Buhta.Kassa.V1alpha1.JournalLogService.listJournalLogs, undefined, undefined, tenant, apiEndpointPrefix + Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log_service.Buhta.Kassa.V1alpha1.JournalLogService.ListJournalLogs.name, undefined, undefined));
}

const JournalLogService = {
  grid: grid$4
};

const KkmUpdateForm = {};

const KkmRegisterForm = {};

const KkmChangeRegisterForm = {};

const KkmUnregisterForm = {};

const KkmLinkForm = {};

const KkmConnectForm = {};

const EtpLinkCreateForm = {};

const EtpLinkUpdateForm = {};

const MoneyPlacementForm = {};

const CloseShiftForm = {};

export {
  Types,
  Kkm,
  EtpLink,
  KkmCreateForm,
  KkmUpdateForm,
  KkmRegisterForm,
  KkmChangeRegisterForm,
  KkmUnregisterForm,
  KkmLinkForm,
  KkmConnectForm,
  KkmManagerService,
  EtpLinkCreateForm,
  EtpLinkUpdateForm,
  KkmEtpService,
  Receipt,
  MoneyPlacement,
  ZxReport,
  JournalLog,
  EtpOrder,
  ReceiptForm,
  MoneyPlacementForm,
  CloseShiftForm,
  EtpReceiptService,
  ReceiptService,
  ZxReportService,
  MoneyPlacementService,
  JournalLogService,
}
/* Buhta_core__Grpc Not a pure module */
